import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";

import { PatientBlockAddComponent } from "./patient-block-add/patient-block-add.component";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { BlockService } from "../../services/Sblock.service";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { Subscription } from "rxjs";
import { SearchModel } from "../../models/MsearchModel";
import { PatientRegistrationService } from "../../services/Spatient-registration.service";
import {
  PATIENT_MYSEARCH,
  PATIENT_SEARCH,
} from "../../properties/patient-search-properties";
import { DatePipe } from "@angular/common";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { PatientDTOObject } from "projects/lib/medcare-core-lib/src/lib/core/patient-search/patient-search.component";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { UtilsService } from "projects/lib/medcare-core-lib/src/lib/services/utils.service";
import { Configuration } from "projects/lib/medcare-core-lib/src/lib/shared/Configuration";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
@Component({
  selector: "app-patient-blocking",
  templateUrl: "./patient-blocking.component.html",
  styleUrls: ["./patient-blocking.component.scss"],
  providers: [DatePipe],
})
export class PatientBlockingComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selected = new FormControl(0);
  dataSource = new MatTableDataSource<any>();
  alldata: any = [];
  displayedColumns: any[] = OPD_CONST.displayedColumnsBlockList;
  selectedPatient: any;
  selectedPatientHistory: any;
  reason: string;
  remarks: string;
  user: any;
  date: any;
  isBlocked: boolean;
  isCTOS: boolean;
  searchJson = PATIENT_SEARCH;
  search: SearchModel = new SearchModel();
  patientSearchList: any;
  refreshTime: string = "";
  patient: PatientDTOObject = new PatientDTOObject();
  hidePatientSearch: boolean = false;
  private subscriptionList = new Subscription();
  patientId: string = "";
  mrn: string = "";
  patientImage: string = "";
  patientInfoDisplay: string = "";
  totalDataLength: number = 0;
  pageSize: number = 0;
  paginatorOptions = Configuration.PAGINATOR_OPTIONS;
  pageIndex: number = 0;
  offsetData: number = 0;
  langaugeValue:string="";
  constructor(
    private blockService: BlockService,
    public authService: AuthService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public router: Router,
    public datePipe: DatePipe,
    private datepipe: DatePipe,
    private utilsService: UtilsService,
    private langService: MultiLanguageService,
    public generalApiService: GeneralUrlService,
    private searchService: SearchService,
    private patientRegService: PatientRegistrationService, 
    private thConvertService:thEnConverterService,
  ) {}

  /**
   *Loading mehod
   *
   * @memberof PatientBlockingComponent
   */
  ngOnInit() {
    this.langaugeValue=localStorage.getItem("lan");
    this.getBlockPatientList(0, 10);
    this.authService.getUser().then((value: any) => {
      this.user = value.userName;
    });

    this.langService.getCurrentLanguage().then((val) => {
      if (val != "en") this.searchJson = PATIENT_MYSEARCH;
      this.getSearchFilter();
    });

    this.langService.changeFooterLaber().then((val) => {
      if(this.paginator){
      this.paginator._intl.itemsPerPageLabel = val;
      }
    });
  }

  /**
   *Back to mainscreen
   *
   * @memberof PatientBlockingComponent
   */
  routerToScreen(): void {
    const dialogRef = this.dialog.open(PatientBlockAddComponent, {
      width: "800px",
      data: {},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.selectedPatient = undefined;
        this.getBlockPatientList(0, 10);
      })
    );
  }

  /**
   *GetBlock patient list method
   *
   * @memberof PatientBlockingComponent
   */
  getBlockPatientList(offset, limit) {
    let reqPayload =
      "identificationId=" +
      this.search.identificationID +
      "&name=" +
      this.search.patientName +
      "&mrn=" +
      this.search.MRN +
      "&gender&unitCode=&city=&identificationType=" +
      this.search.identificationType +
      "&frDate=&toDate=&id=&mobile=" +
      this.search.mobileNo +
      "&birthDate=" +
      this.search.dob +
      "&offset=" + offset + "&size=" + limit + "&pincode=&country=&state=&isBlocked=true";
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OP_PATIENT_SEARCH + reqPayload
        )
        .subscribe((res: any) => {
          this.alldata = this.blockService.getBlockModel(res.patientDetailResponseList);
          this.alldata.forEach(element => {
            element.patientAge=this.generalApiService.calculateAge(element.dob)
            element.dob= element.dob
          ? (this.langaugeValue== Langauge.TH
            ? this.thConvertService.convertThaiDateString(element.dob)
            : this.datePipe.transform(element.dob, "dd-MM-yyyy"))
          : null,
          element.blockedDate= element.blockedDate
          ? (this.langaugeValue== Langauge.TH
            ? this.thConvertService.convertThaiDateString(element.blockedDate)
            : this.datePipe.transform(element.blockedDate, "dd-MM-yyyy"))
          : null
          });
          this.dataSource = new MatTableDataSource<any>(this.alldata);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.totalDataLength = res.totalRecords;
        })
    );
  }

  /*Destroy method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  /**
   *Selected row
   *
   * @param {*} row
   * @memberof PatientBlockingComponent
   */
  selectedRow(row) {
    this.selectedPatient = row;
  }

  public getSearchFilter() {
    let searchList = [];
    this.searchJson.forEach((element) => {
      const controlList = [];
      element.controls.forEach((control) => {
        controlList.push({
          type: control.type,
          placeholder: control.placeholder, // this.environment.placeholder[control.placeholder],
          value: "",
          column: control.column,
          name: control.name,
          url: control.url ? control.url : "",
          selectType: "",
        });
      });
      searchList.push({ controls: controlList });
    });
    this.searchService.setSearch(searchList);

    let searchResult = this.searchService.getResult.subscribe((result) => {
      this.hidePatientSearch = false;
      this.search.MRN = result.mrn;
      this.search.patientName = result.PatienName;
      this.search.dob = result.dob;
      this.search.mobileNo = result.mobileNumber;
      this.search.identificationType = result.identificationType
        ? result.identificationType.code
        : "";
      this.search.identificationID = result.identificationID
        ? result.identificationID
        : "";
      this.patientSearchList = this.search;
      this.refreshTime = new Date().toString();
    });
    this.subscriptionList.add(searchResult);
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        this.search.MRN = quickSearch;
        this.paginator.pageIndex = 0;
        this.getBlockPatientList(0, 10);
      })
      this.subscriptionList.add(quickSearch);
    this.getBlockPatientList(0, 10);
  }

  /**
   * On patient select
   * @param patient patient DTO
   *
   * @memberof PatientRegistrationComponent
   */
  patientOnSelect(patient: PatientDTOObject) {
    this.patient = patient;
    this.patientId = patient.id;
    this.mrn = patient.mrn;
    var dobFormatted = "";
    var patientAge = undefined;
    if (patient.dateOfBirth) {
      dobFormatted = this.datepipe.transform(patient.dateOfBirth, "dd/MM/yyyy");
      let dobDate = new Date(patient.dateOfBirth);
      patientAge = this.utilsService.getAge(dobDate);
      patientAge =
        patientAge > 1
          ? "(" + patientAge + " Years)"
          : "(" + patientAge + " Year)";
    }
    this.patientInfoDisplay =
      patient.mrn +
      " / " +
      patient.fullName +
      " / " +
      (patient.gender ? patient.gender : "Unknown") +
      " / " +
      (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");
    this.patientImage = patient.photo ? patient.photo.url : "";

    this.getBlockPatientList(0, 10);
  }
  /**
   *Patient unblock and Ctos
   *
   * @param {*} isCtos
   * @memberof PatientBlockingComponent
   */
  convertToCTOSUnblock(isCtos) {
    if (this.selectedPatient) {
      this.isBlocked = isCtos ? true : false;
      this.isCTOS = isCtos ? true : false;
      this.openDialog();
    }
  }
  convertToCTOSblock(isCtos) {
    if (!this.selectedPatient.isCTOS) {
      this.isBlocked = isCtos ? true : false;
      this.isCTOS = isCtos ? true : false;
      this.openSecondDialog();
    }else{
      this.snackBar.open(
        this.langService.get("CommonAppoinment.patientAlredyCtos"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 2000,
        }
      );
    }
  }

  /**
   *ctos and release patient window
   *
   * @memberof PatientBlockingComponent
   */
  openDialog(): void {
    const dialogRef = this.dialog.open(PatientBlockDialog, {
      width: "300px",
      data: { reason: this.reason, remarks: this.remarks, pageName: "release"},
    });
    this.subscriptionList.add(
      dialogRef.componentInstance.onClickConfirm.subscribe(() => {
        this.reason = dialogRef.componentInstance.reasonDialog;
        this.remarks = dialogRef.componentInstance.remarkDialog;
        this.formatDataAndPatch();
      })
    );
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.selectedPatient = undefined;
        this.getBlockPatientList(0, 10);
      })
    );
  }
  openSecondDialog(): void {
    const dialogRef = this.dialog.open(PatientBlockDialog, {
      width: "300px",
      data: { reason: this.reason, remarks: this.remarks},
    });
    this.subscriptionList.add(
      dialogRef.componentInstance.onClickConfirm.subscribe(() => {
        this.reason = dialogRef.componentInstance.reasonDialog;
        this.remarks = dialogRef.componentInstance.remarkDialog;
        this.formatDataAndPatch();
      })
    );
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.selectedPatient = undefined;
        this.getBlockPatientList(0, 10);
      })
    );
  }

  /**
   *save ctos and unblcok API details
   *
   * @memberof PatientBlockingComponent
   */
  formatDataAndPatch() {
    let reqPayload = {
      isCTOS: this.isCTOS,
      isBlocked: this.isBlocked,
      reason: this.reason
        ? this.langService.createObjectList(this.reason)
        : null,
      remarks: this.remarks,
    };
    this.subscriptionList.add(
      this.generalApiService
        .patchTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_BLOCK_PATIENT + this.selectedPatient.MongoId,
          reqPayload
        )
        .subscribe((response: any) => {
          if (response) {
            this.snackBar.open(
              this.isCTOS
                ? this.langService.get("payerInfo.ctosBlockedSuccessfully")
                : this.langService.get("payerInfo.patientReleasedSuccessfully"),
              this.langService.get("CommonAppoinment.success"),
              {
                duration: 2000,
              }
            );
          }
        })
    );
  }

  /**
   *History Display
   *
   * @param {*} row
   * @memberof PatientBlockingComponent
   */
  showBlockingHistory(row) {
    this.subscriptionList.add(
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_BLOCKING_HISTORY + row.MongoId
        )
        .subscribe((res: any[]) => {
          if (res) 
          {
          this.selectedPatientHistory = res;
          this.openHistoryDialog();
          }
        })
    );
    //this.selectedPatientHistory = row.patientBlock;
   
  }

  /**
   *opens history dialog
   *
   * @memberof PatientBlockingComponent
   */
  openHistoryDialog(): void {
    this.dialog.open(PatientHistoryDialog, {
      width: "600px",
      data: { patientHistory: this.selectedPatientHistory },
    });
  }

  refreshSearch() {
    this.search.MRN = "";
    this.search.patientName = "";
    this.search.dob = "";
    this.search.identificationType = "";
    this.search.identificationID = "";
    this.search.mobileNo = "";
    this.pageSize=10;
    this.offsetData=0;
    this.getBlockPatientList(this.offsetData, this.pageSize);
  }
  
  getNext(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex ;
    this.offsetData = event.pageIndex * event.pageSize;
    this.getBlockPatientList(this.offsetData, this.pageSize);
  }
}

@Component({
  selector: "dialog-patient-block",
  templateUrl: "./patient-block-history-form/patient-block-dialogue.html",
  styleUrls: ["./patient-blocking.component.scss"],
})
export class PatientBlockDialog implements OnInit, OnDestroy {
  reasonSample: any[] = [];
  remarkDialog: string;
  reasonDialog: string;
  selectedRemarks: string;
  selectedReason: string;
  onClickConfirm = new EventEmitter();
  reasonList: any[]=[];
  reasonSearch: FormControl = new FormControl();
  pageName: string;

  constructor(
    public dialogRef: MatDialogRef<PatientBlockDialog>,
    public generalApiService: GeneralUrlService,
    public snackBar: MatSnackBar,
    private langService: MultiLanguageService, 
    public appBaseService: AppBaseService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.pageName = data.pageName;
  }
  private subscriptionList = new Subscription();

  /*Destroy method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  ngOnInit() {
    
    this.getReasonList();
    this.onChanges();
  }
  onChanges() {
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonSample = this.reasonList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }

  /**
   *On confirmation
   *
   * @param {*} remarksValue
   * @param {*} reasonValue
   * @memberof PatientBlockDialog
   */
  onConfirm(remarksValue, reasonValue) {
    if (reasonValue) {
      this.remarkDialog = remarksValue;
      this.reasonDialog = this.reasonSample.find((i) => i.code == reasonValue);
      this.onClickConfirm.emit();
      this.dialogRef.close();
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseselectreaon"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 2000,
        }
      );
    }
  }

  /**
   *close window
   *
   * @memberof PatientBlockDialog
   */
  onNoClick() {
    this.dialogRef.close();
  }

  /**
   *It is the source of Reason data
   *
   * @memberof PatientRegistrationComponent
   */
  getReasonList() {
    if (this.pageName == "release") {
    this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"PUBL",true)
      .subscribe((res) => {
        res.forEach((element) => {
          this.reasonSample.push(element);
          this.reasonList.push(element);
        });
      });
  }else{
    this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"PTBL",true)
      .subscribe((res) => {
        res.forEach((element) => {
          this.reasonSample.push(element);
          this.reasonList.push(element);
        });
      });
  }
}
}

/**
 *class of history model
 *
 * @export
 * @class HistoryModel
 */
export class HistoryModel {
  status?: string;
  date?: any;
  user?: string;
  reason?: string;
  remarks?: string;
}

@Component({
  selector: "dialog-patient-history",
  templateUrl: "./patient-block-history-form/patient-history-dialog.html",
  styleUrls: ["./patient-blocking.component.scss"],
  providers: [DatePipe],
})
export class PatientHistoryDialog implements OnInit, OnDestroy {
  displayedColumns: any[];
  patientBlock: any;
  patientHistory: any[] = [];
  dataSource = new MatTableDataSource<any>();
  private subscriptionList = new Subscription();
  langaugeValue:string="";

  constructor(
    public dialogRef: MatDialogRef<PatientHistoryDialog>,
    @Inject(MAT_DIALOG_DATA) data: any,
    public thConvertService:thEnConverterService,
    public datePipe: DatePipe,
  ) {
    this.patientBlock = data.patientHistory;
  }

  /**
   *Load History method
   *
   * @memberof PatientHistoryDialog
   */
  ngOnInit() {
    this.langaugeValue=localStorage.getItem("lan");
    this.patientHistory = [];
    this.displayedColumns = OPD_CONST.displayColumnsHistoryBlockList;
    if (this.patientBlock) {
      this.patientBlock.forEach((element) => {
        let historyModel = this.createHistoryModel(element);
        this.patientHistory.push(historyModel);
      });
      this.dataSource = new MatTableDataSource<any>(this.patientHistory);
    }
   
  }

  /*Destroy method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  /**
   *close history method
   *
   * @memberof PatientHistoryDialog
   */
  onNoClick() {
    this.dialogRef.close();
  }

  /**
   *create history method
   *
   * @param {*} model
   * @return {*}  {HistoryModel}
   * @memberof PatientHistoryDialog
   */
  createHistoryModel(model): HistoryModel {
    let statusString = " ";
    if (model.isCTOS) {
      statusString = OPD_CONST.displayBlockStatus.ctosBlocked;
    } else if (model.isBlocked) {
      statusString = OPD_CONST.displayBlockStatus.blocked;
    } else {
      statusString = OPD_CONST.displayBlockStatus.unBlocked;
    }

    let blockingDate: string;
    if (model.addedOn) {
      let time = model.addedOn * 1000;
      blockingDate = this.datePipe.transform(new Date(time), "dd-MM-yyyy");


      blockingDate=blockingDate
          ? (this.langaugeValue== Langauge.TH
            ? this.thConvertService.convertThaiDateString(blockingDate)
            : blockingDate)
          : null;
    }

    const patientHistoryModel: HistoryModel = {
      date: blockingDate,
      user: model.addedBy,
      reason: model.reason?model.reason.desc:"",
      remarks: model.remark,
      status: statusString,
    };

    return patientHistoryModel;
  }
}
